<template>
  <button
    type="button"
    :class="[
      'btn-white-2',
      disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
    ]"
    :disabled="disabled"
  >
    <i v-if="icon" :class="icon" />
    <span v-if="icon && label" class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "whiteButton",
  props: ["label", "icon", "disabled"]
};
</script>
